export const READ_WEATHERS = "READ_WEATHERS";
export const WEATHER_ERROR = "WEATHER_ERROR";
export const CLEAR_WEATHER = "CLEAR_WEATHER";
export const START_WEATHERS_RELOAD = "START_WEATHERS_RELOAD";
export const FINISHED_WEATHERS_RELOAD = "FINISHED_WEATHERS_RELOAD";
